import { defineContent } from './defineContent.js';
import data from './hero.json';
import { heroSchema } from './hero.schema.js';

export const hero = defineContent(heroSchema, data);
